import { useAppSelector } from 'app/hooks';
import type { IDashboardColumn } from 'models';
import { sortLabel } from '../dashboardUtils';

/**
 * In-table infobar (§3.F) — Total Projects / Filtered / Sorted-by. Reuses
 * common.css `.helper` + `.list-inline` styling (already loaded globally).
 *
 *  - Total Projects: the server's state-independent `total_count` (grand total
 *    across all project states, ignoring search filters) — infobar.js:59-64.
 *  - Filtered: ALWAYS rendered (infobar.js:67 — NOT gated on a filter being
 *    active); value = projects.models.length + pined_projects.models.length,
 *    i.e. the rows currently rendered (pinned + default accumulation),
 *    increasing as infinite scroll appends pages. The state tabs and the
 *    column searches both flow through it naturally (QA #7).
 *  - Sorted by {Project Name | Created on | column} or "User Custom Sorted".
 *
 * Whitespace parity (QA #3): infobar.tmpl puts the `<li>`s on separate lines
 * and a newline between each label span and its value span — each collapses to
 * one space ("Total Projects : 157"). JSX strips inter-element whitespace, so
 * the {' '} text nodes restore it.
 */
interface InfobarProps {
  total: number;
  /** count of rows currently rendered (pinned + default). */
  renderedCount: number;
  columns: IDashboardColumn[] | undefined;
}

const Infobar = ({ total, renderedCount, columns }: InfobarProps) => {
  const sortBy = useAppSelector((s) => s.dashboard.sortBy);
  const isManual = useAppSelector((s) => s.dashboard.isManual);
  const label = sortLabel(sortBy, isManual, columns);

  return (
    <ul className="list-inline clearfix">
      <li className="count">
        <span>Total Projects :</span> <span className="value">{total}</span>
      </li>{' '}
      <li className="filter">
        <span>Filtered :</span> <span className="value">{renderedCount}</span>
      </li>{' '}
      <li className="sort_by">
        <span className="value">{label}</span>
      </li>
    </ul>
  );
};

export default Infobar;
